"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

var SvgNavigation2 = function SvgNavigation2(props) {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M18.887 31.77l4.617-2.638a1 1 0 01.992 0l4.617 2.638L24 17.893 18.887 31.77zm-1.39 3.098c-.811.463-1.758-.338-1.435-1.214l7-19c.321-.872 1.555-.872 1.876 0l7 19c.323.876-.624 1.677-1.434 1.214L24 31.152l-6.504 3.716z",
    id: "navigation-2_svg__a"
  }));
};

var _default = SvgNavigation2;
exports["default"] = _default;